export default "__VITE_ASSET__mAh_RqGM__"